import { TableColumnDefinition, createTableColumn, TableCellLayout } from '@fluentui/react-components'
import { PeopleTeam24Regular } from '@fluentui/react-icons'
import { RestSchemas } from '@/contexts/QueryProvider'
import { RowActionsMenu } from './RowActionsMenu'

type MessagesApplicationsApplicationTeam = RestSchemas['Messages.Applications.ApplicationTeam']

export const appTeamsTableColumns: TableColumnDefinition<MessagesApplicationsApplicationTeam>[] = [
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'name',
    compare: (a, b) => {
      return a.name?.localeCompare(b.name)
    },
    renderHeaderCell: () => {
      return 'Team'
    },
    renderCell: (item) => {
      return (
        <TableCellLayout media={<PeopleTeam24Regular color={'#D04A02'} />}>
          <div className="flex flex-col gap-1 py-2 leading-4">
            <span style={{ fontSize: '16px' }}>{item.name}</span>
            <span style={{ color: '#979797', fontSize: 'small' }}>{item.description}</span>
            <span style={{ color: '#979797', fontSize: 'small' }}>{item.application}</span>
          </div>
        </TableCellLayout>
      )
    },
  }),
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'linkedProjectCount',
    compare: (a, b) => {
      return a.linkedProjectCount - b.linkedProjectCount
    },
    renderHeaderCell: () => {
      return 'Projects'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedProjectCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'activeLinkedProjectCount',
    compare: (a, b) => {
      return a.activeLinkedProjectCount - b.activeLinkedProjectCount
    },
    renderHeaderCell: () => {
      return 'Active projects'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.activeLinkedProjectCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'linkedUserCount',
    compare: (a, b) => {
      return a.linkedUserCount - b.linkedUserCount
    },
    renderHeaderCell: () => {
      return 'Users'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedUserCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'linkedRoleCount',
    compare: (a, b) => {
      return a.linkedRoleCount - b.linkedRoleCount
    },
    renderHeaderCell: () => {
      return 'Roles'
    },
    renderCell: (item) => {
      return <TableCellLayout>{item.linkedRoleCount.toString()}</TableCellLayout>
    },
  }),
  createTableColumn<MessagesApplicationsApplicationTeam>({
    columnId: 'actions',
    renderHeaderCell: () => {
      return 'Actions'
    },
    renderCell: (item) => <RowActionsMenu appTeam={item} />,
  }),
]
